import { Card } from "antd";
import { renderer } from "../../helpers/";

const renderBlock = (block: any) => {
    const {
        data: { other: { description = [] } = {} },
    } = block;
    return (
        <div>
            <Card>{renderer(description)}</Card>
        </div>
    );
};

export default renderBlock;
